if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter'),
          resetButton: this.querySelector('.country-filter__reset-button'),
        };

        this.options = [];
        this.currentIndex = -1;

        this.onKeyDown = this.onKeyDown.bind(this);
      }

      connectedCallback() {
        this.elements.button?.addEventListener('click', this.toggleSelector.bind(this));

        // 🔥 FIX: bind keyboard correctly
        this.elements.button?.addEventListener('keydown', this.onKeyDown);
        this.elements.panel?.addEventListener('keydown', this.onKeyDown);

        // KEEP original Shopify behavior
        this.querySelectorAll('a').forEach((item) =>
          item.addEventListener('click', this.onItemClick.bind(this))
        );

        document.addEventListener('click', this.onClickOutside.bind(this));

        this.setupOptions();
      }

      /* ================= OPTIONS ================= */

      setupOptions() {
        this.options = Array.from(this.querySelectorAll('[role="option"]'));

        this.options.forEach((el, index) => {
          el.setAttribute('tabindex', '-1');
          el.dataset.index = index;
        });
      }

      /* ================= OPEN / CLOSE ================= */

      toggleSelector() {
        const isOpen = this.elements.panel.classList.contains('active');
        isOpen ? this.hidePanel() : this.openPanel();
      }

      openPanel() {
        this.elements.panel.classList.add('active');
        this.elements.button.setAttribute('aria-expanded', 'true');

        this.setupOptions();

        // 🔥 KEY FIX: move focus inside
        this.focusOption(0);
      }

      hidePanel() {
        this.elements.panel.classList.remove('active');
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.currentIndex = -1;
      }

      /* ================= FOCUS ================= */

      focusOption(index) {
        if (!this.options.length) return;

        this.currentIndex = index;

        const option = this.options[this.currentIndex];
        option.focus();
      }

      /* ================= KEYBOARD ================= */

      onKeyDown(e) {
        const isOpen = this.elements.panel.classList.contains('active');

        // 🔥 OPEN with keyboard
        if (!isOpen && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
          e.preventDefault();
          this.openPanel();

          if (e.key === 'ArrowUp') {
            this.focusOption(this.options.length - 1);
          } else {
            this.focusOption(0);
          }
          return;
        }

        if (!isOpen) return;

        switch (e.key) {
          case 'Escape':
            this.hidePanel();
            this.elements.button.focus();
            break;

          case 'ArrowDown':
            e.preventDefault();
            this.focusOption((this.currentIndex + 1) % this.options.length);
            break;

          case 'ArrowUp':
            e.preventDefault();
            this.focusOption(
              (this.currentIndex - 1 + this.options.length) % this.options.length
            );
            break;

          case 'Enter':
          case ' ':
            e.preventDefault();
            this.options[this.currentIndex]?.click();
            break;
        }
      }

      /* ================= CLICK ================= */

      onClickOutside(event) {
        if (!this.contains(event.target)) {
          this.hidePanel();
        }
      }

      onItemClick(event) {
        event.preventDefault();

        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;

        form?.submit();
      }
    }
  );
}